// React
import React, {Component} from 'react';
import {connect} from 'react-redux';
import clsx from 'clsx';
// Routing
import {withRouter} from "react-router-dom";
// Material UI
import {Drawer, IconButton} from '@material-ui/core';
// ICONS
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
// Infrastructure
import {put_lang} from "@api/Users";
// Components
import {SelectSimple} from "../../Input";
// Translations
import {withTranslation} from "react-i18next";
// STYLES
import {withStyles} from '@material-ui/core/styles';
import {getSidebarStyles} from "./styles/styles";
import './styles/styles.scss';
// Vendor
import {setCookieByName, userLangObject, isSuperAdmin, resetState, deleteAllCookies} from '@helpers';
import $ from "jquery";
// Img
import user_png from "@img/user.png";
// Chargebee API
import {ChargebeeAPI} from '@api/Chargebee';
// CONSTANTS
const useStyles = (theme) => (getSidebarStyles(theme, 'right', 450));
// Amplitude API
import {AmplitudeAPI} from '@api/Amplitude';

class ProfileSidebar extends Component {
    constructor(props) {
        super(props);
        let cbCustomerId = props.data.user.chargebee_customer_id;
        this.state = {
            cbInstance: cbCustomerId != '-' ?
                window.Chargebee.init({
                    site: props.data.user.chargebee_customer_site
                }) : null
        }
    }

    changeLanguage = (lang) => {
        this.props.i18n.changeLanguage(lang);
        setCookieByName(lang, 'b__lg');

        this.updateLang(lang);
    }

    handleScript = () => {
        var iframe = $('#bim-ifr');
        iframe?.remove();
    }

    updateLang = async (lang) => {
        const {user} = this.props;
        try {
            user.lang = lang;
            await put_lang(this.props, user);
            this.handleAmplitude("Language change", lang);
            this.handleScript();
        } catch (err) {
        }
    }

    handleRoutes = (type) => {
        const {history} = this.props;
        const platform = process.env.REACT_APP_PLATFORM;
        switch (platform) {
            case 'admin':
                history.push(`/${type}`);
                break;
            case 'centribot':
            case 'centridesk':
                window.location.href = `${process.env.REACT_APP_URL_CENTRIMANAGER}/${type}`;
                break;
        }
    }

    handleAmplitude = (event_type, lang) => {
        const {user, device_id} = this.props.data;
        new AmplitudeAPI({
            event_type: event_type,
            device_id: device_id,
            user_id: user.email,
            event_properties: {
                platform: process.env.REACT_APP_PLATFORM,
                action: lang
            }
        }).eventLog();
    }

    shutDown = (e) => {
        e.preventDefault();
        const {history, dispatch} = this.props;
        const platform = process.env.REACT_APP_PLATFORM;

        this.handleAmplitude("Sign off");
        dispatch(resetState());
        deleteAllCookies();
        switch (platform) {
            case 'admin':
            case 'centridesk':
                window.location.href = `${process.env.REACT_APP_URL_CENTRIBOT}/landing/login`;
                break;
            case 'centribot':
                history.push('/landing/login');
                break;
        }
    }

    handleShowPortal = async (e) => {
        const {user} = this.props;
        const {access, auth} = this.props.data;
        await this.state.cbInstance.setPortalSession(() => {
            let data = JSON.stringify({chargebee_customer_id: user.chargebee_customer_id})
            let chargebee_api = new ChargebeeAPI(user.id, access ? access : auth.access, this.props, data)
            return chargebee_api.get_chargebee_user_portal();
        })

        let chargebee_logout = () => this.state.cbInstance.logout();

        this.state.cbInstance.createChargebeePortal().open({
            close: function () {
                chargebee_logout()
            }
        });
    }

    render() {
        const {classes, open, handleMenuToggle, plan, i18n, title, t} = this.props;
        return (
            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx(classes.paper, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                {
                    <IconButton
                        id={"toggle_btn_profile"}
                        disableRipple disableFocusRipple
                        onClick={handleMenuToggle}
                        className={clsx(classes.collapseButton, {
                            [classes.collapseButtonOpen]: open,
                            [classes.collapseButtonClose]: !open
                        })}
                    >
                        <ChevronRightIcon style={{fontSize: 35, paddingRight: 18}}/>
                    </IconButton>
                }
                <div className="platform_profile_header">
                    <img src={user_png} alt={"user"}/>
                    <div>
                        <h2>{title}</h2>
                        <p>{t('commons:sidebars.profile.description')}</p>
                    </div>
                </div>
                <div className="platform_profile_content">
                    {plan && (
                        <div className={`platform_profile_plan ${plan.plan.name}`}>
                            <div>
                                <span>{t('commons:sidebars.profile.active_plan')}</span>
                                <div>
                                    <p dangerouslySetInnerHTML={{__html: t(`commons:sidebars.profile.plan.${plan.plan.name}`)}}></p>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="platform_profile_list">
                        <div className={"platform_profile_list__actions"}>
                            <div className="platform_profile_lang">
                                {t('commons:sidebars.profile.items.language')}
                                <SelectSimple
                                    valueSelected={t(`commons:input.select.language.${i18n.language}`)}
                                    items={userLangObject()}
                                    onSelect={this.changeLanguage}
                                    placeholder={t(`commons:input.select.language.placeholder`)}
                                    type={'translate'}
                                    className={'select_secondary'}
                                    value={"value"}
                                    translate_pattern={'commons:input.select.language.'}
                                    t={t}
                                />
                            </div>
                            {
                                isSuperAdmin(this.props.data.user) &&
                                this.props.user.chargebee_customer_id !== "-" &&
                                this.props.data.user.username !== 'gonzalo.berrmejo@makro.es' &&
                                <p id={"list_chargebee_portal"}
                                   onClick={(e) => this.handleShowPortal(e)}>{t('commons:sidebars.profile.items.manageaccount')}</p>
                            }
                            <p id={"list_sign_off_profile"}
                               onClick={(e) => this.shutDown(e)}>{t('commons:sidebars.profile.items.sign_off')}</p>
                        </div>
                        <div className={"platform_profile_list__links"}>
                            <a href={`https://centribal.com/${i18n.language === 'es' ? 'es/politica-de-privacidad' : 'us/privacy-policy'}`}
                               target={"__blank"}>{t('commons:sidebars.profile.items.privacy_policy')}</a>
                            <a href={`${i18n.language === 'es' ? 'https://centribal.com/es/aviso-legal' : 'https://centribal.com/wp-content/uploads/2021/06/LEGAL-NOTICE-2021-centribal.pdf'}`}
                               target={"__blank"}>{t('commons:sidebars.profile.items.legal_notice')}</a>
                            <a href={`https://centribal.com/${i18n.language === 'es' ? 'es/politica-de-cookies' : 'us/cookies-policy'}`}
                               target={"__blank"}>{t('commons:sidebars.profile.items.cookies_policy')}</a>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    }
}

const connect_profile_sidebar = connect(
    mapStateToProps
)(ProfileSidebar);

export default withRouter(withTranslation()(withStyles(useStyles)(connect_profile_sidebar)));